/* eslint-disable react/jsx-props-no-spreading */
import { MenuItem } from "@material-ui/core";
import { useField, useFormikContext } from "formik";
import PropTypes from "prop-types";
import React from "react";
import TextField from "./TextField";

const SelectField = ({ options, name, onSelect, submitOnChange, ...other }) => {
  const [field] = useField(name);
  const { submitForm } = useFormikContext();
  return (
    <TextField
      select
      name={field.name}
      value={field.value}
      onChange={e => {
        field.onChange(e);
        if (onSelect) {
          onSelect(e);
        }
        if (submitOnChange) {
          submitForm();
        }
      }}
      {...other}
    >
      {(options || []).map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
};

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
    })
  ).isRequired
};

export default SelectField;
